export default "__VITE_ASSET__AJNNq51V__"